import { render, staticRenderFns } from "./AddPad.vue?vue&type=template&id=13e9bc62&scoped=true&"
import script from "./AddPad.vue?vue&type=script&lang=js&"
export * from "./AddPad.vue?vue&type=script&lang=js&"
import style0 from "./AddPad.vue?vue&type=style&index=0&id=13e9bc62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e9bc62",
  null
  
)

export default component.exports